import { Column } from '../MetadataColumnHeaders';

export const twoColumns: Column[] = [
	{
		header: 'Metadataveld',
		width: 50,
	},
	{
		header: 'Waarde',
		width: 50,
	},
];

export const threeColumns: Column[] = [
	{
		header: 'Metadataveld',
		width: 40,
	},
	{
		header: 'Waarde',
		width: 30,
	},
	{
		header: 'Individueel wijzigen',
		width: 30,
	},
];
